import { useNavigate } from "react-router-dom";

export const FloatingBtn = () => {
  const navigate = useNavigate();
  return (
    <div className="hidden md:flex z-[999] fixed flex-col shadow-[0px_4px_44px_rgba(0,0,0,0.15)] rounded-[12px] bg-white right-[28px] bottom-[130px]">
      <div className="p-3 flex border-b-[1px] border-b-[#DDE0E6] h-[112px]">
        <div
          id="btn-floating-apply"
          className="
    flex flex-col px-2 py-3 gap-[10px] items-center justify-center cursor-pointer
    border-[3px] border-transparent rounded-[12px]
    [background-origin:border-box]
    [background-clip:padding-box,border-box]
    bg-[linear-gradient(#fff,#fff),linear-gradient(90deg,#0079FF_0%,#00FF44_56.09%,#FFC400_100%)]
  "
          onClick={() => {
            navigate("/inquiry-form?type=adoption");
          }}
        >
          <img src="/assets/images/icon/floating_inquiry.png" width={24} alt="floating" />
          <span className="font-normal text-[20px] text-[#121319]">도입문의</span>
        </div>
      </div>
      <div
        id="btn-floating-doc"
        className="flex flex-col  px-2 py-3 gap-[10px] items-center justify-center cursor-pointer h-[112px]
       "
        onClick={() => {
          navigate("inquiry-form?type=introduction");
        }}
      >
        <img src="/assets/images/icon/floating_introduction.png" width={24} alt="floating" />
        <span className="font-normal text-[20px] text-[#121319]">소개서</span>
      </div>
    </div>
  );
};
